import { useContent } from '@/content'
import { Surface } from '@/components/ui'
import styles from './AwardsSection.module.css'

/** Certifications panel on the about page. */
export const AwardsSection = () => {
  const { awards } = useContent()

  return (
  <Surface pad={20} radius="card" className={styles.panel}>
    <h2 className="t-24">Certifications</h2>
    <ul className={styles.list}>
      {awards.map((award) => (
        <Surface as="li" key={award.id} interactive className={styles.item}>
          <div>
            <h3 className="t-18">{award.name}</h3>
            <p className={`t-14 ${styles.issuer}`}>{award.issuer}</p>
          </div>
          <p className={`t-12 ${styles.period}`}>{award.period}</p>
        </Surface>
      ))}
    </ul>
  </Surface>
  )
}
